import { render } from "./LegacyGroupMktReport.vue?vue&type=template&id=2c345667"
import script from "./LegacyGroupMktReport.vue?vue&type=script&lang=js"
export * from "./LegacyGroupMktReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__